import { LanguageServer } from './language-server';
import { globalLanguage } from './global';
import { LangProvider } from './lang-provider';
import { LanguageInterpolator } from './language-interpolator';
import { InterpolationCache } from './interpolation-cache';
import { LanguageResources, LanguageResourcesCollection } from './language-resources';
import { LanguageResourceData } from './language-item-data';
import { defaultLanguage } from './consts';
import { ILanguageResources } from './interfaces';

export function intializeLocalizationServices(
  languages: string[],
  glossary: LanguageResourceData[],
  langFiles: LanguageResourceData[],
  defaultResources: () => ILanguageResources,
  hasLocalization: boolean = true
) {
  globalLanguage.languageServer = new LanguageServer();
  globalLanguage.languageProvider = new LangProvider(globalLanguage.languageServer);
  globalLanguage.interpolationCache = new InterpolationCache(globalLanguage.languageProvider);
  globalLanguage.languageInterpolator = new LanguageInterpolator(
    globalLanguage.languageProvider,
    globalLanguage.interpolationCache
  );
  globalLanguage.languageCollection = new LanguageResourcesCollection();
  globalThis.globalLanguageDebugMode = sessionStorage.getItem('language:enableDebugMode') === 'true';
  //build application default language file
  let defaultLanguageFile = defaultResources();
  globalLanguage.languageCollection.resources.push(defaultLanguageFile);

  //build server default glossary file or throw an error if not found.
  const defaultGlossary = glossary.find(x => x.language === defaultLanguage);
  const defaultGlossaryResources = defaultGlossary
    ? LanguageResources.FromLanguageItemData(defaultGlossary)
    : undefined;
  if (defaultGlossaryResources) {
    globalLanguage.languageCollection.resources.push(defaultGlossaryResources);
  } else {
    if (hasLocalization) throw new Error(`Default glossary resources not found for language ${defaultLanguage}`);
  }

  //look for a replacement for the default language and push it in to the collection.
  const defaultLang = langFiles.find(x => x.language === defaultLanguage);
  if (defaultLang) {
    defaultLanguageFile = LanguageResources.FromLanguageItemData(defaultLang);
    globalLanguage.languageCollection.swap(defaultLanguageFile);
  }

  // Add the default language to the server
  globalLanguage.languageServer.addLanguage(globalLanguage.languageCollection);
  var defaultCollection = globalLanguage.languageServer.getLanguage(defaultLanguage);

  var otherLanguages = languages.filter(x => x !== defaultLanguage);
  //add other languages
  // if a languge file is not found, we will fall back to the default language file rather than crashing.
  for (const language of otherLanguages) {
    //make a clone of the default language collection as a fallback.
    const newLang = defaultCollection.asLanguage(language);

    const lang = langFiles.find(x => x.language === language);
    //swap the default language file with the new language file.
    if (lang) newLang.swap(LanguageResources.FromLanguageItemData(lang));
    const newGlossary = glossary.find(x => x.language === language);
    if (newGlossary) newLang.swap(LanguageResources.FromLanguageItemData(newGlossary));

    globalLanguage.languageServer.addLanguage(newLang);
  }
}
